import { MODULE_ID } from './constants';
export const CLEAR_ORGANIZATION = `${MODULE_ID}/CLEAR_ORGANIZATION`;
export const FETCH_ORGANIZATION_MEMBERSHIPS = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS`;
export const FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS`;
export const FETCH_ORGANIZATION_MEMBERSHIPS_ERROR = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS_ERROR`;
export const APPROVE_MEMBERSHIP = `${MODULE_ID}/APPROVE_MEMBERSHIP`;
export const APPROVE_MEMBERSHIP_SUCCESS = `${MODULE_ID}/APPROVE_MEMBERSHIP_SUCCESS`;
export const APPROVE_MEMBERSHIP_ERROR = `${MODULE_ID}/APPROVE_MEMBERSHIP_ERROR`;
export const REJECT_MEMBERSHIP = `${MODULE_ID}/REJECT_MEMBERSHIP`;
export const REJECT_MEMBERSHIP_SUCCESS = `${MODULE_ID}/REJECT_MEMBERSHIP_SUCCESS`;
export const REJECT_MEMBERSHIP_ERROR = `${MODULE_ID}/REJECT_MEMBERSHIP_ERROR`;
export const DELETE_MEMBERSHIP = `${MODULE_ID}/DELETE_MEMBERSHIP`;
export const DELETE_MEMBERSHIP_SUCCESS = `${MODULE_ID}/DELETE_MEMBERSHIP_SUCCESS`;
export const DELETE_MEMBERSHIP_ERROR = `${MODULE_ID}/DELETE_MEMBERSHIP_ERROR`;
export const CREATE_INVITATION = `${MODULE_ID}/CREATE_INVITATION`;
export const CREATE_INVITATION_SUCCESS = `${MODULE_ID}/CREATE_INVITATION_SUCCESS`;
export const CREATE_INVITATION_ERROR = `${MODULE_ID}/CREATE_INVITATION_ERROR`;
export const CANCEL_INVITATION = `${MODULE_ID}/CANCEL_INVITATION`;
export const CANCEL_INVITATION_SUCCESS = `${MODULE_ID}/CANCEL_INVITATION_SUCCESS`;
export const CANCEL_INVITATION_ERROR = `${MODULE_ID}/CANCEL_INVITATION_ERROR`;
export const RESEND_INVITATION = `${MODULE_ID}/RESEND_INVITATION`;
export const RESEND_INVITATION_SUCCESS = `${MODULE_ID}/RESEND_INVITATION_SUCCESS`;
export const RESEND_INVITATION_ERROR = `${MODULE_ID}/RESEND_INVITATION_ERROR`;
export const GRANT_ADMIN = `${MODULE_ID}/GRANT_ADMIN`;
export const GRANT_ADMIN_SUCCESS = `${MODULE_ID}/GRANT_ADMIN_SUCCESS`;
export const GRANT_ADMIN_ERROR = `${MODULE_ID}/GRANT_ADMIN_ERROR`;
export const REVOKE_ADMIN = `${MODULE_ID}/REVOKE_ADMIN`;
export const REVOKE_ADMIN_SUCCESS = `${MODULE_ID}/REVOKE_ADMIN_SUCCESS`;
export const REVOKE_ADMIN_ERROR = `${MODULE_ID}/REVOKE_ADMIN_ERROR`;
